class Whatsapp {
	constructor(config) {
		this.config = Object.assign({
			scope: '.whatsapp-link',
			toggleBox: '.whatsapp-box',
			toggleButtonSelector: '.js-whatsapp-open'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.toggleWhatsappBox.bind(this));
	}

	toggleWhatsappBox() {
		this.$scope.find(this.config.toggleBox).toggle();
	}
}

export default new Whatsapp;